export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: 'var(--font-heading)' }}>
              随时随地，畅享国产影视
            </h2>
            <p className="mt-3 text-sm text-white/80 leading-relaxed">
              91在线视频已全面适配移动端，支持手机浏览器直接访问，无需下载安装即可在线观看高清国产电影和电视剧。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white hover:bg-background-100 text-primary-600 font-semibold text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机端体验
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium text-sm rounded-lg border border-white/20 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
            </div>
          </div>

          <div className="relative flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20Chinese%20video%20streaming%20app%20interface%2C%20movie%20thumbnails%20on%20screen%2C%20modern%20phone%20design%2C%20warm%20screen%20glow%2C%20minimalist%20setup%2C%20clean%20white%20background%2C%20soft%20shadows%2C%20premium%20product%20photography&width=360&height=640&seq=app-mockup&orientation=landscape"
              alt="91在线视频移动端观影体验"
              className="w-48 md:w-56 h-auto rounded-2xl shadow-lg"
              onError={(e) => {
                const target = e.currentTarget;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}